import { render, staticRenderFns } from "./investmentClues9.vue?vue&type=template&id=2bc8fa35&scoped=true&"
import script from "./investmentClues9.vue?vue&type=script&lang=js&"
export * from "./investmentClues9.vue?vue&type=script&lang=js&"
import style0 from "./investmentClues9.vue?vue&type=style&index=0&id=2bc8fa35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc8fa35",
  null
  
)

export default component.exports